import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Typography } from '@mui/material';

interface SaveBarErrorProps {
    message: string;
    actionText?: string;
    onAction?: () => void;
    showIcon?: boolean;
}

export const SaveBarError = ({
    message,
    actionText,
    onAction,
    showIcon = true,
}: SaveBarErrorProps) => {
    const lineHeight = '24px';

    return (
        <Box
            display="flex"
            alignItems="flex-start"
            sx={{
                color: 'text.primary',
                fontSize: '13px',
                fontWeight: 400,
                lineHeight,
                minWidth: 0,
            }}
        >
            {showIcon && (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexShrink: 0,
                        height: lineHeight,
                        marginRight: '8px',
                    }}
                >
                    <ErrorOutlineIcon
                        sx={{
                            color: 'error.main',
                        }}
                    />
                </Box>
            )}
            <Box sx={{ minWidth: 0 }}>
                {actionText && onAction && (
                    <Typography
                        component="span"
                        onClick={onAction}
                        sx={{
                            color: 'primary.main',
                            fontSize: '13px',
                            fontWeight: 400,
                            lineHeight,
                            cursor: 'pointer',
                            textDecoration: 'none',
                            '&:hover': {
                                textDecoration: 'underline',
                            },
                        }}
                    >
                        {actionText}
                    </Typography>
                )}
                {actionText && onAction && <>&nbsp;</>}
                <Typography
                    component="span"
                    sx={{
                        fontSize: 'inherit',
                        fontWeight: 'inherit',
                        lineHeight: 'inherit',
                    }}
                >
                    {message}
                </Typography>
            </Box>
        </Box>
    );
};
